import { StyledTable, StyledTableWrapper, StyledVirtualListWrapper } from "./Table.styles";

/**
 * A wrapper component for the table to apply outer layout or styling.
 *
 * Params
 * - children (ReactNode): The content to be rendered inside the wrapper.
 * - ...props (any): Additional props passed to the StyledTableWrapper component.
 *
 * Returns
 * - JSX.Element: A styled table wrapper containing the passed children.
 */
export const TableWrapper = ({ children, ...props }) => {
  return <StyledTableWrapper {...props}>{children}</StyledTableWrapper>;
};

/**
 * A styled table component for rendering tabular data.
 *
 * Params
 * - children (ReactNode): The rows, columns, or other content to render inside the table.
 * - ...props (any): Additional props passed to the StyledTable component.
 *
 * Returns
 * - JSX.Element: A styled table element with the given content.
 */
export const Table = ({ children, ...props }) => {
  return <StyledTable {...props}>{children}</StyledTable>;
};

/**
 * A wrapper for the virtualized list to ensure correct positioning and overflow handling.
 *
 * Params
 * - props (any): Props passed to the underlying styled component.
 *
 * Returns
 * - JSX.Element: A styled div wrapper for the virtual list.
 */
export const VirtualListWrapper = props => <StyledVirtualListWrapper {...props} />;
